<template>
  <div>
    <div class="report-viewer" v-show="showViewer">
      <Transition name="fade">
        <div class="spinner-background" v-show="!doneLoading">
          <div class="report-loading spinner">
            Loading...
          </div>
        </div>
      </Transition>
      <div class="icons">
        <div v-if="fileVals.docType.includes('html')">
          <a :href=fileVals.reportData target="_blank">
            <span class="material-symbols-outlined close open-new">open_in_new</span>
          </a>
        </div>
        <div>
          <span class="material-symbols-outlined close" @click="hideViewer">close</span>
        </div>
      </div>
      <Transition name="fade2">
        <vue-pdf-embed ref="pdfRef" :source="fileVals.reportData" v-show="fileVals.docType.includes('pdf')"
          @rendered="handleDocumentRender" />
      </Transition>
      <Transition name="fade2">
        <div class="plain-text" v-show="fileVals.docType.includes('text')">
          {{ fileVals.reportData }}
        </div>
      </Transition>
      <Transition name="fade2">
        <div class="html-page" v-show="fileVals.docType.includes('html')">
          <iframe id="iFrame" :src="fileVals.reportData"></iframe>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import VuePdfEmbed from 'vue-pdf-embed'

const store = useStore()
const doneLoading = ref(false)

const docType = computed(() => store.getters.reportDocType || '')
const reportData = computed(() => store.getters.reportDocument || '')
const fileVals = ref({ docType, reportData })
const showViewer = computed(() => store.getters.showViewer || false)

watch(reportData, () => {
  doneLoading.value = false
  fileVals.value.docType = docType
  fileVals.value.reportData = reportData
  // seting a timeout to clear any previous data before the new data is loaded.
  setTimeout(function () {
    fileVals.value.docType = docType
    fileVals.value.reportData = reportData
    if (fileVals.value.docType.includes('text') || fileVals.value.docType.includes('html')) {
      doneLoading.value = true
    }
  }, 1000)
})

watch(showViewer, async () => {
  doneLoading.value = false
})

const handleDocumentRender = () => {
  doneLoading.value = true
}

const hideViewer = () => {
  fileVals.value = {
    docType: docType,
    reportData: '',
  }
  store.dispatch('showViewer', false)
  store.dispatch('reportDocType', '')
  store.dispatch('reportDocument', '')
  doneLoading.value = false
}
</script>

<style lang="scss" scoped>
.icons {
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
}

#iFrame {
  height: calc(100vh - 70px);
  width: calc(90vw - 400px);
}

.close {
  cursor: pointer;
  z-index: 10000;
}

.open-new {
  margin-right: 2rem;
}

.report-viewer {
  position: fixed;
  z-index: 90;
  top: 70px;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  overflow-y: auto;

  div {
    width: 70vw;
    margin: auto;
  }
}

.spinner-background {
  position: fixed;
  z-index: 100;
  top: 70px;
  left: 0;
  width: 100vw !important;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  overflow-y: auto;
}

.report-viewer .close {
  position: fixed;
  top: 90px;
  right: 40px;
  color: var(--White)
}

.plain-text {
  margin: auto;
  background-color: var(--White);
  text-align: left;
  white-space: pre-wrap;
  padding: 2rem;
  padding-bottom: 100px;
  opacity: 1;
}

.report-loading {
  width: 25% !important;
  margin: auto;
  color: var(--White);
  margin-top: 100px !important;
  padding-bottom: 40px;
  margin-bottom: 100px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 300ms ease;
}

.fade2-enter-from,
.fade2-leave-to {
  opacity: 0;
}
</style>
